<template>
  <section class="relative overflow-hidden bg-white py-12 dark:bg-slate-950 md:py-16">
    <div class="mx-auto max-w-6xl px-4 sm:px-6">
      <div class="grid items-center gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:gap-14">
        <div class="max-w-3xl">
          <h2
            class="text-3xl font-bold leading-[1.12] text-slate-700 dark:text-white sm:text-4xl md:text-5xl"
          >
            {{ storyCopy.title }}
          </h2>
          <div
            class="mt-6 space-y-4 text-base leading-relaxed text-slate-500 dark:text-slate-300 md:mt-7 md:space-y-5 md:text-lg"
          >
            <!-- Phones get the first paragraph only: this section sits right after the hero. -->
            <p
              v-for="(paragraph, i) in storyCopy.paragraphs"
              :key="paragraph"
              :class="{ 'hidden sm:block': i > 0 }"
            >
              {{ paragraph }}
            </p>
          </div>
          <NuxtLink
            class="mt-9 inline-flex rounded-md bg-[#0e7490] px-7 py-3 text-base font-medium text-white transition-colors hover:bg-[#155e75]"
            :to="localePath(ctaTo)"
            data-conversion-event="explore_click"
            data-conversion-label="Home story about link"
            data-conversion-location="home-story"
          >
            {{ resolvedCtaLabel }}
          </NuxtLink>
        </div>

        <div class="relative mx-auto w-full max-w-[200px] sm:max-w-[260px] lg:max-w-[360px]">
          <div
            class="relative aspect-[1.03] overflow-hidden rounded-[3rem] bg-slate-100 shadow-sm dark:bg-slate-900"
          >
            <img
              src="/home/operators-reviewing-client-work.webp"
              srcset="/home/operators-reviewing-client-work-400.webp 400w, /home/operators-reviewing-client-work-640.webp 640w, /home/operators-reviewing-client-work.webp 1000w"
              sizes="(min-width: 1024px) 360px, (min-width: 640px) 260px, 200px"
              width="1000"
              height="666"
              :alt="tr('Workspace369 operators reviewing client work')"
              loading="lazy"
              class="h-full w-full object-cover"
            />
            <div class="absolute inset-0 bg-white/5"></div>
            <img
              width="1455" height="1450" loading="lazy" src="/home/workspace369_icon_white2.webp"
              srcset="/home/workspace369_icon_white2-400.webp 400w, /home/workspace369_icon_white2-640.webp 640w, /home/workspace369_icon_white2.webp 1455w"
              sizes="(min-width: 1024px) 360px, (min-width: 640px) 260px, 200px"
              alt=""
              aria-hidden="true"
              class="absolute inset-0 h-full w-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    ctaTo?: string;
    ctaLabel?: string;
  }>(),
  {
    ctaTo: "/about",
  }
);

const { localePath } = useWorkspaceLocale();
const homeCopy = useHomeCopy();
const { tr } = useHomeI18n();
const storyCopy = computed(() => homeCopy.value.story);
const resolvedCtaLabel = computed(() => props.ctaLabel || storyCopy.value.cta);
</script>
